import { render, staticRenderFns } from "./vip-goods-content.vue?vue&type=template&id=244283d4&scoped=true"
import script from "./vip-goods-content.vue?vue&type=script&lang=js"
export * from "./vip-goods-content.vue?vue&type=script&lang=js"
import style0 from "./vip-goods-content.vue?vue&type=style&index=0&id=244283d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244283d4",
  null
  
)

export default component.exports